@if (content$ | async | foldSuccess; as content) {
	<div class="custom-html-container">
		@if (content.enable) {
			<div [innerHTML]="content.html | trustedHtml"></div>
		}
	</div>
}
